import { useContext } from 'react';
import { ViewerStateContext } from "../context/viewer-state.js";
export const useViewerState = () => useContext(ViewerStateContext);
//# sourceMappingURL=use-viewer-state.js.map